import * as React from "react"
import styled from "styled-components"
import BasketItem from "./BasketItem"
import * as colors from "../../constants/colors"
import ByoBasketItem from "./ByoBasketItem"
import { BasketItemType } from "model"

const Container = styled.div``
const ItemContainer = styled.div`
  &:not(:last-child) {
    border-bottom: 1px solid ${colors.borderGrey};
    margin-bottom: 10px;
    padding-bottom: 10px;
  }
`

interface Props {
  items: BasketItemType[]
  adjustable?: boolean
  smallImage?: boolean
}

const BasketItems = ({ items, adjustable, smallImage = false }: Props) => {
  const normalBasketItems = items.filter(item => !item.type)
  const byoBoxItem = items.find(item => item.type === "byoBox")
  const byoCardItem = items.find(item => item.type === "byoGiftCard")
  const byoItems = items.filter(item => item.type === "byo")

  const hasByo = byoBoxItem || (byoItems && byoItems.length > 0)
  return (
    <Container>
      {hasByo && (
        <ItemContainer>
          <ByoBasketItem
            box={byoBoxItem}
            items={byoItems}
            card={byoCardItem}
            adjustable={adjustable}
          />
        </ItemContainer>
      )}
      {normalBasketItems.map(item => (
        <ItemContainer>
          <BasketItem item={item} adjustable={adjustable} smallImage={smallImage} />
        </ItemContainer>
      ))}
    </Container>
  )
}

export default BasketItems
